export function getFileNameFromUrl(url) {
  if (!url?.trim()) return "arquivo";

  try {
    const pathname = new URL(url).pathname;
    const name = decodeURIComponent(pathname.split("/").pop() || "");
    return name || "arquivo";
  } catch {
    const segment = url.split("/").pop()?.split("?")[0] || "";
    return decodeURIComponent(segment) || "arquivo";
  }
}

export function isImageUrl(url) {
  return /\.(jpe?g|png|webp|gif|svg)(\?|$)/i.test(url || "");
}

export function isVideoUrl(url) {
  return /\.(mp4|mov|avi|webm|mkv)(\?|$)/i.test(url || "");
}

export function isPdfUrl(url) {
  return /\.pdf(\?|$)/i.test(url || "");
}
